'use strict'

var uikit = require('../uikit');

module.exports = uikit.mediator;
module.exports.default = uikit.mediator;



// WEBPACK FOOTER //
// ./assets/js/mediator.js